export default __webpack_public_path__ + "static/media/comma.31e789b4.svg";